import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const DeleteInlineCommentMutation: GraphQLTaggedNode = graphql`
	mutation DeleteInlineCommentMutation(
		$commentIdToDelete: ID!
		$deleteFrom: CommentDeletionLocation
	) {
		deleteComment(commentIdToDelete: $commentIdToDelete, deleteFrom: $deleteFrom)
	}
`;
